import axios from 'axios'
import router from '@/router'
import { localize } from 'vee-validate'
import { i18n } from '../translate'

const APIUrl = process.env.VUE_APP_API_URL
const defaultMsg = `Sorry, we can't verify the email, please enter a valid email`

export default {
  isPublic ({ state }, pageName) {
    if (pageName.toLowerCase() === 'home') return true
    const page = state.pageProperties.pages.find(page => page.pageName === pageName)
    return page && Boolean(page.isPublic);
  },
  handleError: ({ commit, dispatch, state }, err) => {
    const page = state.pageProperties;
    let e = undefined
    const errors = page.errors ? page.errors[i18n.locale] : []
    if (errors) {
      if (err && err.cause)
        e = errors[err.cause]
      else
        e = errors['default']
    } else {
      e = i18n.t(`Sorry, we can't verify the email, please enter a valid email`)
    }
    // console.error(e)
    console.log(e, err, errors)
    if (err && err.message) {
      commit('setModalOptions', { type: 'error', isActive: true, message: err.message })
    } else {
      commit('setModalOptions', { type: 'error', isActive: true, message: e })
    }
  },

  setPageProperties: ({
    commit
  }, properties) => {
    commit('setPageProperties', properties);
  },

  getTemplateData: ({ commit, dispatch, state }, url) => {
    return new Promise((resolve, reject) => {

      if (process.env.NODE_ENV === 'development') {
        state.pageProperties.testing = true
      } else {
        state.pageProperties.testing = false
      }
      let data = {
        campaignId: state.pageProperties.campaignId
      }

      const siteLanguages = state.pageProperties.languages
      if (siteLanguages && siteLanguages.length && window.location.pathname == '/') {
        const browserLang = navigator.language.toLowerCase()

        for (let i = 0; i < siteLanguages.length; i++) {
          if (browserLang.includes(siteLanguages[i].lang) && window.location.pathname != siteLanguages[i].url) {
            window.location.replace(siteLanguages[i].url)
            break;
          }
        }
      }

      data = { ...data, ...router.currentRoute.query, jstc: 1 }
      axios.post(`${APIUrl}/tempId`, data)
        .then(resp => {
          if (resp.data.response) {
            const data = {
              field: 'customerToken',
              value: resp.data.customerToken
            }
            commit('setField', data)
          } else {
            dispatch('handleError', { cause: `server` })
            reject(false)
          }
        }).catch(ex => {
          dispatch('handleError')
        })
      resolve(state.pageProperties)
    })
      .then((pageProperties) => {
        const dictionary = pageProperties.dictionary
        if (dictionary) {
          // merges with built-in phrases
          localize(dictionary)
        }
        if (pageProperties.header && pageProperties.header.properties.favicon) {
          updateFavicon(pageProperties.header.properties.favicon.imageSource);
        }
        return pageProperties
      })
  },

  setTemplateData: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      // console.log("SET TEMPLATE DADTA", APIUrl, data)
      axios.post(`${APIUrl}/savePage`, data).then(res => {
        commit('setPageProperties', res.data);
        return resolve(res.data)
      })
    })
  },

  refreshTempId: ({ commit, getters }) => {
    return new Promise((resolve, reject) => {
      axios.post(`${APIUrl}/tempId`, { campaignId: getters.campaignId })
        .then(resp => {
          if (resp.data.response) {
            const data = {
              field: 'customerToken',
              value: resp.data.customerToken
            }
            if (location.pathname !== "/iban-erneut-einreichen") commit('setField', data)
            resolve(resp.data)
          }
        })
    })
  },

  setComponentStatus: ({ commit }, { component, status }) => {
    commit('setComponentStatus', { component, status });
  },

  sendFormData({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {

      if (window.nsId) {
        data.formData.nsId = window.nsId;
      }

      axios.post(data.apiUrl, data.formData)
        .then(res => {
          if (data.triggers && data.triggers.neuStarTrigger) {
            // console.log("3. will send::: neutrigger", data.triggers)
            let a = window._agknEchoTag;
            if (a && data.n) {
              a.setBpId('firstp');
              a.addEchoKeyValue('event', 'submit');
              a.generateTag();
            }
          }
          if (res.data.response) {
            resolve(res.data)
          } else {
            if (res.data.invalid_fields && res.data.invalid_fields.length !== 0) {
              //janrain error
              dispatch('handleError', { message: res.data.invalid_fields[0] })
            } else {
              dispatch('handleError')
            }
            reject(res.data)
          }
        })
        .catch(ex => {
          dispatch('handleError')
          return { success: false, error: ex.message }
        })
    })
  },

  uploadReceipt({ getters, commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      const formData = new FormData()
      if (data.receiptToken) {
        formData.append('receiptToken', data.receiptToken)
      }
      formData.append('userToken', data.customerToken)
      formData.append('receipt', data.image, 'receipt.png')
      formData.append('subCampaignId', getters.campaignId)
      formData.append('campaignId', data.campaignId)

      if (data.token) {
        formData.append('token', data.token)
      }
      axios.post(`${data.apiUrl}`, formData)
        .then(resp => {
          if (resp.data.response !== 'ERR') {
            commit('setReceiptToken', resp.data.receiptToken)
            resolve(resp.data.receiptToken);
          } else {
            dispatch('handleError', resp.data.error)
            reject(resp.data)
          }
        })
        .catch(resp => {
          dispatch('handleError', { message: i18n.t('Oops. An error has occurred. Please try again later.') })
          reject(resp)
        })
    })
  },
  sendSubmitPoruduct: ({ getters, commit, dispatch }) => {
    let data = {};
    data.campaignId = getters.campaignId;
    data.customerToken = getters.customerToken;
    data.receiptToken = getters.receiptToken;
    data.selectedProducts = [{ ean: getters.getModelNumber, name: getters.getModelNumber, count: 1 }];
    return new Promise((resolve, reject) => {
      axios.post(`${APIUrl}/submitProducts`, data).then(res => {
        resolve(res.data)
      }).catch(err => {
        reject(err)
      })
    })
  },

  isUpdateIban: ({ commit, getters }, data) => {
    return new Promise((resolve, reject) => {
      axios.get(`https://js-backend.justsnap.eu/api/ibanUpdateCheck/${data.customerToken}/${getters.campaignId}`)
        .then(resp => {
          resolve(resp.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
}
export function updateFavicon(url) {
  const link =
    document.querySelector("link[rel*='icon']") ||
    document.createElement("link");
  link.type = "image/x-icon";
  link.rel = "shortcut icon";
  link.href = url;
  document.getElementsByTagName("head")[0].appendChild(link);
}